import { Link } from 'react-router-dom';
import { GameLayout } from './GameLayout';

export function MafiaLanding() {
  return (
    <GameLayout>
      <MafiaStyles />
      <span className="label">/ Mafia Live · автоматический ведущий</span>
      <h1 className="mafia-title">
        Мафия без <span className="accent-word">ведущего</span>.
      </h1>
      <p className="lede">
        Один создаёт комнату, вводит имена, показывает QR — и тоже играет. Дальше приложение ведёт само: раздаёт
        роли, включает ночной звук, принимает ходы мафии, доктора и комиссара, считает голоса и объявляет победителя.
      </p>

      <div className="mafia-actions">
        <Link to="/play/mafia/create" className="btn-primary lg">
          Создать игру →
        </Link>
        <Link to="/rooms" className="btn-ghost lg">
          Войти по коду
        </Link>
      </div>

      <div className="mafia-grid">
        <FeatureCard n="01" title="Имена заранее" text="Никаких шуток-ников. Все имена вводит создатель до старта — игроки только выбирают своё." />
        <FeatureCard n="02" title="QR-вход" text="Сканируешь код — попадаешь в комнату. Ссылка тоже работает. Переподключение после разрыва — автоматически." />
        <FeatureCard n="03" title="Роли в тайне" text="Сервер знает роли, клиент — нет. Каждый видит только свою. Утром — публичный счёт голосов, без «кто кого»." />
        <FeatureCard n="04" title="Звук вместо ведущего" text="Ночные фразы и фоновый звук на всех телефонах одновременно, чтобы не угадать, кто проснулся." />
      </div>

      <div className="mafia-rules">
        <h2>Как играть</h2>
        <ol>
          <li>Создатель вводит список игроков (от 5 до 12) или грузит сохранённую команду.</li>
          <li>Показывает QR. Все выбирают своё имя и жмут «войти».</li>
          <li>Когда все на месте — «Старт». Приложение раздаёт роли.</li>
          <li>Ночью просыпается мафия, потом доктор, потом комиссар — каждый у себя на экране.</li>
          <li>Днём — обсуждение вживую и голосование в приложении. Побеждает тот, у кого больше голосов.</li>
          <li>Так до победы мафии или мирных. В конце — полная история партии.</li>
        </ol>
      </div>
    </GameLayout>
  );
}

function FeatureCard({ n, title, text }: { n: string; title: string; text: string }) {
  return (
    <div className="feature">
      <span className="mono" style={{ fontSize: 11, color: 'var(--ink-faint)', letterSpacing: '0.16em' }}>
        {n}
      </span>
      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  );
}

function MafiaStyles() {
  return (
    <style>{`
      .mafia-title { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 88px; line-height: 1.02; letter-spacing: -.015em; margin: 12px 0 0; }
      .lede { max-width: 640px; font-size: 17px; line-height: 1.55; color: var(--ink-dim); margin: 24px 0 40px; }
      .mafia-actions { display: flex; gap: 12px; flex-wrap: wrap; margin-bottom: 64px; }
      .mafia-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 64px; }
      .feature { background: var(--bg2); border: 1px solid var(--line); border-radius: var(--radius-card); padding: 24px; }
      .feature h3 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 26px; margin: 12px 0 8px; letter-spacing: -.005em; }
      .feature p { font-size: 13px; line-height: 1.5; color: var(--ink-dim); margin: 0; }
      .mafia-rules h2 { font-family: 'Oswald', sans-serif; font-weight: 600; font-size: 40px; letter-spacing: -.01em; margin: 0 0 20px; }
      .mafia-rules ol { max-width: 640px; padding-left: 20px; color: var(--ink-dim); line-height: 1.7; font-size: 15px; }
      .mafia-rules li { margin-bottom: 8px; }
      @media (max-width: 900px) { .mafia-grid { grid-template-columns: 1fr 1fr; } .mafia-title { font-size: 56px; } }
      @media (max-width: 560px) { .mafia-grid { grid-template-columns: 1fr; } }
    `}</style>
  );
}
